<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleName: ''
    }
  },
  methods: {
    getTitleName () {
      this.$api.index.getTitleName().then(res => {
        if (res.code === 200) {
          this.titleName = res.data?.title
          document.title = this.titleName
        }
      })
    }
  },
  created () {
    this.getTitleName()
  }
}
</script>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'wryht';
}
html, body, div, span, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
abbr, address, cite, code,
del, dfn, em, img, ins, kbd, q, samp,
small, strong, sub, sup, var,
b, i,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, figcaption, figure,
footer, header, hgroup, menu, nav, section, summary,
time, mark, audio, video {
  margin:0;
  padding:0;
  border:0;
  outline:0;
  font-size:100%;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  vertical-align:baseline;
  background:transparent;
}

body {
  line-height:1;
}

:focus {
  outline: 1;
}

article,aside,canvas,details,figcaption,figure,
footer,header,hgroup,menu,nav,section,summary {
  display:block;
}

nav ul {
  list-style:none;
}

blockquote, q {
  quotes:none;
}

blockquote:before, blockquote:after,
  q:before, q:after {
  content:'';
  content:none;
}

a {
  margin:0;
  padding:0;
  border:0;
  font-size:100%;
  text-decoration: none;
  vertical-align:baseline;
  background:transparent;
}

ins {
  background-color:#ff9;
  color:#000;
  text-decoration:none;
}

mark {
  background-color:#ff9;
  color:#000;
  font-style:italic;
  font-weight:bold;
}

del {
  text-decoration: line-through;
}

abbr[title], dfn[title] {
  border-bottom:1px dotted #000;
  cursor:help;
}

table {
  border-collapse:collapse;
  border-spacing:0;
}

hr {
  display:block;
  height:1px;
  border:0;
  border-top:1px solid #cccccc;
  margin:1em 0;
  padding:0;
}

input, select {
  vertical-align:middle;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.container{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.flex{
  display: flex;
}
.just-center{
  justify-content: center;
}
.just-between{
  justify-content: space-between;
}
.just-around{
  justify-content: space-around;
}
.just-end{
  justify-content: flex-end;
}
.align-center{
  align-items: center;
}
.align-start{
  align-content: flex-start;
}
.item-start{
  align-items: flex-start;
}
.flex-1{
  flex: 1;
}
.flex-column{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
input{
  outline: none;
  border: none;
    }
input::-webkit-outer-spin-button,
::-webkit-inner-spin-button{
  -webkit-appearance: none;
}
.position-rela{
  position: relative;
}
.text-center{
  text-align: center;
}
.w-h-100{
  width: 100%;
  height: 100%;
}
.font-bold{
  font-weight: bold;
}
.cursor-pointer{
  cursor: pointer;
}
.mainBg{
  background-color: #fffc;
}
ul li{
  list-style: none;
}
.search-box{
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #eee;
}
.ql-align-center{
  text-align: center;
}
.ql-align-right{
  text-align: right;
}
.ql-indent-1{
  padding-left: 16px;
}
.ql-indent-2{
  padding-left: 32px;
}
.ql-indent-3{
  padding-left: 48px;
}
.ql-indent-4{
  padding-left: 64px;
}
.ql-indent-5{
  padding-left: 80px;
}
.ql-indent-6{
  padding-left: 96px;
}
.ql-indent-7{
  padding-left: 112px;
}
.ql-indent-8{
  padding-left: 128px;
}
</style>
